module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"btn":{"donar_efectivo":"DONAR EN EFECTIVO","donar_pasarela":"DONAR POR PASARELA"},"mensaje_error":{"error_iniciar_pasarela":"La pasarela no ha podido iniciar","obra_no_valida":"La obra seleccionada no es valida, o posee un error de configuración"}}}')
  delete Component.options._Ctor
}
